import React from 'react';
import { SetupArea } from 'nekst-api';
import { Dropdown } from 'ui-builder';

export function VersionDropdown(props: {
  setupArea: SetupArea
}) {
  return (
    <Dropdown
      options={props.setupArea.versions.map((item) => ({
        label: item.version,
        value: item.version,
      }))}
      source="sourceVersion"
    />
  );
}
